import React, { useEffect } from 'react';

// assets

// services
import OrderService from '../../../../../../services/orders/order';

// props
import { ICompanyResourceShort } from '../../../../../../props/users/company';
import { IDeliveryTypeResourceShortProps } from '../../../../../../props/deliveryType';
import { IFreightCategoryResourceShortProps } from '../../../../../../props/freightCategories';
import { IUserResourceShortProps } from '../../../../../../props/users/user';

// components
import { DefaultButton, IContextualMenuItem } from '@fluentui/react';
import FilterPanel, { FilterOptionProps } from '../../../../../uiframeworks/filters/panel';
import { IOrderStatusResourceShortProps } from '../../../../../../props/orders/orderStatus';
import ISubsidiariesResourceShort from '../../../../../../props/data/subsidiaries';
import OutcomeService from '../../../../../../services/finance/outcomes';
import OutcomePaymentService from '../../../../../../services/finance/outcomes/payments';
import { IBankAccountResourceShortProps } from '../../../../../../props/general/bankAccount';
import { IVendorResourceShortProps } from '../../../../../../props/data/vendors';
import OutcomeTypes from '../../../../../../manifests/outcomeTypes';
import SubsidiariesService from '../../../../../../services/data/subsidiaries';
import VendorsService from '../../../../../../services/data/vendors';
import OutcomeCategoryService from '../../../../../../services/finance/outcomes/categories';
import { IOutcomeCategoryResourceShortProps } from '../../../../../../props/finance/outcomes/categories';

interface OutcomePaymentsListFilterButtonProps {
    filters?: TFilterBy[];
    selected: FilterOptionProps[];
    onChange(selected: FilterOptionProps[]): void;
}

export type TFilterBy = 'bank_account' | 'subsidiary' | 'vendor' | 'purpose';

const OutcomePaymentsListFilterButton: React.FC<OutcomePaymentsListFilterButtonProps> = (props: OutcomePaymentsListFilterButtonProps) => {
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [by, setBy] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<FilterOptionProps[]>(props.selected);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    const _onFilterApplied = (_selected: FilterOptionProps[]) => {
        props.onChange(_selected);
        setActiveSurface(undefined);
        setBy(undefined);
    }

    const _onCancelled = () => {
        setBy(undefined);
        setActiveSurface(undefined);
    }

    const getQueryString = () => {
        const qs: string[] = [];

        const groupedFilter: { key: string, options: FilterOptionProps[] }[] = [];
        selected.map((sel) => {
            const gfidx = groupedFilter.findIndex((gf) => gf.key === sel.filterby);
            if (gfidx > -1) {
                groupedFilter[gfidx].options.push(sel);
            } else {
                groupedFilter.push({
                    key: sel.filterby,
                    options: [sel]
                });
            }
        });

        groupedFilter.forEach((gf) => {
            qs.push(`${gf.key}=${gf.options.map((opt) => opt.key).join(';')}`);
        });

        return qs.join("&");
    }

    const _onRenderOptions = async (): Promise<FilterOptionProps[]> => {
        if (by) {
            const key = by.toLowerCase().split(" ").join("_");
            const options: FilterOptionProps[] = [];

            if (key === 'subsidiary') {
                const results = (await SubsidiariesService.retrieve("top=all"));
                results.forEach((res: ISubsidiariesResourceShort) => {
                    options.push({
                        filterby: key,
                        filterbyText: 'Subsidiary',
                        key: res.id,
                        title: res.name,
                        description: res.npwp,
                        metadata: res
                    });
                })
            } else if (key === 'vendor') {
                const results = (await VendorsService.retrieve("top=all&status=verified;verified_with_risk;expired")).data;
                results.forEach((res: IVendorResourceShortProps) => {
                    options.push({
                        filterby: key,
                        filterbyText: 'Vendor',
                        key: res.id,
                        title: res.name,
                        metadata: res
                    });
                })
            } else if (key === 'category') {
                const results = (await OutcomeCategoryService.retrieve("top=all"));
                results.forEach((res: IOutcomeCategoryResourceShortProps) => {
                    options.push({
                        filterby: key,
                        filterbyText: 'Category',
                        key: res.id,
                        title: res.name,
                        group: res.group,
                        metadata: res
                    });
                })
            }
            console.log(options);

            return options;
        } else {
            return [];
        }
    }

    const renderFilterButton = () => {
        const items: IContextualMenuItem[] = [];
        const filteredby: string[] | undefined = props.filters ? (props.filters || []).map((f) => f.toLowerCase()) : undefined;

        if (!filteredby || (filteredby || "").indexOf('subsidiary') > -1) {
            items.push({
                key: 'subsidiary',
                text: 'By subsidiary',
                onClick: () => {
                    setBy('subsidiary');
                    setActiveSurface('filter');
                }
            });
        }

        if (!filteredby || (filteredby || "").indexOf('category') > -1) {
            items.push({
                key: 'category',
                text: 'By category',
                onClick: () => {
                    setBy('category');
                    setActiveSurface('filter');
                }
            });
        }

        return <DefaultButton menuIconProps={{ iconName: "Filter" }} text={"Filter"} menuProps={{ items }} />
    }

    return <>
        {renderFilterButton()}
        {activeSurface === 'filter' && by ? <>
            <FilterPanel title={"Filter by " + by}
                onRenderOptions={_onRenderOptions}
                selected={selected}
                onCancel={_onCancelled}
                onApply={_onFilterApplied} />
        </> : null}
    </>
};

export default OutcomePaymentsListFilterButton;
